export const FSID_DOMAIN_PREFIX_MAP = {
  local: 'staging-',
  production: '',
  qa: 'qa-',
  staging: 'staging-',
  testing: 'testing-',
};
